import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAddPhone from './modal/phonemodal.vue'
import { toast } from '@/shared/utils/UIHelper'
import AssociateCreate from '../../../associate/components/associateCreate.vue'

export default {
  name: 'CrmDetailsContacts',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    phones: {
      type: Array,
      default: null
    },
    cardActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showConversation: false,
      data: null,
      form: null,
      conversationAssociate: null
    }
  },
  components: {
    AssociateCreate,
    ModalAddPhone
  },
  methods: {
    openShowMessages (conversationAssociate, telefone) {
      this.$refs.newConversationModal.openModal(conversationAssociate, telefone)
    },
    onLoad () {},
    onAddPhone () {
      this.$refs.ModalAddPhone.showModal()
    },
    closeShowMessages () {
      this.$refs.newConversationModal.closeModal()
    },
    onReload () {
      this.$emit('Reload')
    },
    toastInfo () {
      toast.info('Esta funcionalidade ainda não está disponível no seu nxCoop.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/contacts/contact.js